<script lang="ts">
    import {getInjector} from 'src/core';
    import type {ToastMessage} from './types';
    import {ToastMessageService} from './toast-message.service';
    import {onDestroy} from 'svelte';
    import {flip} from 'svelte/animate';
    import {fly} from 'svelte/transition';
    import {cleanup} from 'shared/utils/custom-utils';
    import ToastMessageCard from './ToastMessageCard.svelte';

    const service = getInjector().getByClass(ToastMessageService);
    const flipAnimParams = {duration: 250};
    const flyAnimParams = {x: 50, duration: 250};

    let toastMessages: ToastMessage[] = [];
    const toastsSubscription = service.getToasts$().subscribe((toasts) => toastMessages = toasts);

    onDestroy(() => {
        cleanup(toastsSubscription);
    });
</script>

<div class="kp-toast-messages"
     role="alert"
     aria-atomic="false"
     class:is-empty={toastMessages.length === 0}>

    {#each toastMessages as toast(toast.id)}
        <div class="animation-container"
             animate:flip={flipAnimParams}
             transition:fly={flyAnimParams}>

            {#if toast.customComponent}
                <svelte:component this={toast.customComponent} {toast} {...toast.customComponentProps ?? {}}/>
            {:else}
                <ToastMessageCard {toast}/>
            {/if}
        </div>
    {/each}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .kp-toast-messages {
        display: flex;
        flex-direction: column;
        top: @spacing-l;
        right: 0;
        margin-right: @spacing-xl;
        margin-left: @spacing-xl;
        width: calc(100dvw - @spacing-xl * 2);
        max-width: 300px;
        position: fixed;
        z-index: @toasts-z-index;

        &.is-empty {
            pointer-events: none;
        }
    }
</style>